import { CarouselBlock } from "@/scott/ui/blocks/carousel/carousel";
import type { ContentSliderPageBlock } from "@/types/page-block";
import type { PageContext } from "@/types/page-context";
import { ContentBlocks } from "./content-blocks";

export type ContentSliderBlockProps = ContentSliderPageBlock & {
  pageContext: PageContext["pageContext"];
};

export function ContentSliderBlock(props: Readonly<ContentSliderBlockProps>) {
  const slides = props.slides.map((block, index) => ({
    id: block.id ?? `${props.id}-slide-${index}`,
    content: <ContentBlocks blocks={[block]} pageContext={props.pageContext} />,
  }));

  return <CarouselBlock {...props} mode="D2C" slides={slides} />;
}
